import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
            <div className="consider_content">
              <h2>When to Consider Our Web3 App Development Services</h2>
              <p>
                Whether you’re starting from scratch or upgrading, we ensure
                smooth and customized solutions for your Web3 application
                development needs. From Web3 game creation to cutting-edge
                financial systems, our Web3 developers paving the road for
                decentralized innovation.
              </p>
              <p>
                Here’s when you should consider our Web3 development services:
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Start Your Web3 Journey Today!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="consider-box">
              <h6>Decentralized Solutions:</h6>
              <p>
                Our decentralized solutions provide enhanced control over data
                and security, allowing for a smooth transition to Web3 while
                utilizing disruptive decentralized technology benefits.
              </p>
            </div>
            <div className="consider-box">
              <h6>Tokenization:</h6>
              <p>
                If you want to improve asset management, liquidity, and
                accessibility in decentralized ecosystems, we can assist you
                tokenize assets, allowing for fractional ownership and more
                participation.
              </p>
            </div>
            <div className="consider-box">
              <h6>Scalable Solutions:</h6>
              <p>
                Our Web3 app solutions are designed to evolve automatically with
                your organization, assuring long-term performance and
                adaptability.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Considerapp;
